import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	searchLabel: {
		id: 'software-code-code-page.pages.main-page.pull-requests.pull-request-list.filters.repository-filter.search-label',
		defaultMessage: 'Search for repositories…',
		description:
			'Label shown on the search input when there is too many options to choose from in the repository filter dropdown',
	},
	repositorySelectLabel: {
		id: 'software-code-code-page.pages.main-page.pull-requests.pull-request-list.filters.repository-filter.repository-select-label',
		defaultMessage: 'Repository',
		description: "Label shown on the repository's filter dropdown",
	},
	unknownRepository: {
		id: 'software-code-code-page.pages.main-page.pull-requests.pull-request-list.filters.repository-filter.unknown-repository',
		defaultMessage: 'Unknown',
		description: 'Name shown for an unknown repository',
	},
});
